import { FaTwitter, FaInstagram, FaFacebookF, FaYoutube, FaLinkedin } from "react-icons/fa";
import { IoLogoDiscord } from "react-icons/io5";

export const SOCIAL_LINKS = [
    {
        href: 'https://twitter.com/Marketrack_2047',
        icon: FaTwitter,
        label: 'X'
    },
    {
        href: 'https://www.instagram.com/marketrack.in/',
        icon: FaInstagram,
        label: 'Instagram'
    },
    {
        href: 'https://www.facebook.com/profile.php?id=61555364248436',
        icon: FaFacebookF,
        label: 'Facebook'
    },
    {
        href: 'https://www.youtube.com/channel/UCba3FbtgUHv_diqqJ--sZHA',
        icon: FaYoutube,
        label: 'Youtube'
    },
    {
        href: '/',
        icon: FaLinkedin,
        label: 'LinkedIn'
    },
    {
        href: 'http://Discordapp.com/users/1199561766837948476',
        icon: IoLogoDiscord,
        label: 'Discord'
    }
];

export const DESKTOP_QUICK_LINKS = [
    {
        title: 'Quick Links',
        links: [
            { to: '/about', label: 'About' },
            { to: '/about', label: 'Blog' },
            { to: '/about/team', label: 'Team' },
            { to: '#', label: 'Careers' },
            { to: '#', label: 'Contact' }
        ]
    },
    {
        title: 'Policies',
        links: [
            { to: '#', label: 'Privacy Policy' },
            { to: '#', label: 'Terms of Use' },
            { to: '#', label: 'Cookie Policy' }
        ]
    }
];

export const MOBILE_QUICK_LINKS = [
    {
        title: 'Quick Links',
        links: [
            { to: '/', label: 'Product' },
            { to: '/about', label: 'About' },
            { to: '/about', label: 'Blog' },
            { to: '#', label: 'Pricing' }
        ]
    },
    {
        title: 'Reach Out',
        links: [
            { to: '#', label: 'Careers' },
            { to: '/about/team', label: 'Team' },
            { to: '#', label: 'Contact' }
        ]
    },
    {
        title: 'Policies',
        links: [
            { to: '#', label: 'Privacy Policy' },
            { to: '#', label: 'Terms of Use' },
            { to: '#', label: 'Cookie Policy' }
        ]
    }
];

export const MOBILE_BREAKPOINT = 744;